/* Jabree — Post-purchase upsell page (jab-upsell)
   - reads ?bought=<category> and shows the matching offer group (falls back to default)
   - per-card size select, then one-tap add -> checkout with the % off discount applied
   - Collective band: native form add -> /checkout (selling plan); "maybe later" dismiss
   No dependencies. Scoped to .jup. */
(function () {
  var root = document.querySelector('.jup');
  if (!root) return;

  var DISCOUNT = (root.getAttribute('data-discount-code') || '').trim();

  function checkoutURL() {
    if (DISCOUNT) return '/discount/' + encodeURIComponent(DISCOUNT) + '?redirect=%2Fcheckout';
    return '/checkout';
  }

  /* ---------- pick the offer group matching what they bought ---------- */
  function showGroupForBought() {
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-trigger]'));
    if (!groups.length) return;
    var params = new URLSearchParams(window.location.search);
    var bought = (params.get('bought') || '').toLowerCase().trim();

    var match = null, fallback = null;
    groups.forEach(function (g) {
      if (g.getAttribute('data-default') === 'true') fallback = g;
      var trig = (g.getAttribute('data-trigger') || '').toLowerCase();
      var list = trig.split(',').map(function (s) { return s.trim(); });
      if (bought && list.indexOf(bought) !== -1 && !match) match = g;
    });
    var chosen = match || fallback || groups[0];
    groups.forEach(function (g) { g.hidden = (g !== chosen); });
  }

  /* ---------- size selection ---------- */
  root.addEventListener('click', function (e) {
    var sz = e.target.closest && e.target.closest('.jup__size');
    if (!sz || sz.disabled) return;
    var card = sz.closest('.jup__card');
    if (!card) return;
    card.querySelectorAll('.jup__size').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
    sz.setAttribute('aria-pressed', 'true');
    card.setAttribute('data-variant', sz.getAttribute('data-variant') || '');
    var hint = card.querySelector('.jup__addHint');
    if (hint) hint.textContent = '';
  });

  /* ---------- add to order ---------- */
  function xhr(method, url, data, ok, fail) {
    var r = new XMLHttpRequest();
    r.open(method, url, true);
    r.setRequestHeader('Content-Type', 'application/json');
    r.onload = function () {
      if (r.status >= 200 && r.status < 300) { try { ok(JSON.parse(r.responseText || '{}')); } catch (x) { ok({}); } }
      else if (fail) fail();
    };
    r.onerror = fail || function () {};
    r.send(data ? JSON.stringify(data) : null);
  }

  root.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.jup__add');
    if (!btn || btn.tagName === 'A' || btn.disabled) return;
    var card = btn.closest('.jup__card');
    if (!card) return;

    var vid = card.getAttribute('data-variant') || btn.getAttribute('data-variant') || '';
    var hasSizes = !!card.querySelector('.jup__size');
    var hint = card.querySelector('.jup__addHint');

    if (hasSizes && !vid) {
      if (hint) hint.textContent = 'Pick a size first';
      var row = card.querySelector('.jup__sizes');
      if (row) { row.animate ? row.animate([{ transform: 'translateX(-3px)' }, { transform: 'translateX(3px)' }, { transform: 'translateX(0)' }], { duration: 180 }) : 0; }
      return;
    }
    if (!vid) return;

    btn.classList.add('is-loading');
    var go = function () { window.location.href = checkoutURL(); };
    xhr('POST', '/cart/add.js', { items: [{ id: parseInt(vid, 10), quantity: 1 }] }, go, function () {
      btn.classList.remove('is-loading');
      if (hint) hint.textContent = 'Sold out in that size — try another';
    });
  });

  /* ---------- Collective: maybe later ---------- */
  var maybe = root.querySelector('.jup__collMaybe');
  if (maybe) {
    maybe.addEventListener('click', function () {
      var band = root.querySelector('.jup__collective');
      if (band) band.style.display = 'none';
      var skip = root.querySelector('.jup__skip');
      if (skip) skip.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  showGroupForBought();
})();
